export const version = 1

export default {
	'incomeReceived' : {
		name: 'Income Received',
		allowDoNotNotify: true,
		doNotNotifyText: "Don't miss important alerts. With this option, MyBudget will no longer notify you when your income is received."

	},
	'lateIncome' : {
		name: 'Income Not Received',
		description: `We currently only offer SMS as an alert option for missed incomes. Because missing income can significantly affect the running of your budget, it is important that you are notified immediately.`,
		allowDoNotNotify: true,
		doNotNotifyText: "Don't miss important alerts. With this option, MyBudget will no longer notify you if income is not received."
	},
	'latePayment' : {
		name: 'Late Payment',
		allowDoNotNotify: true,
		doNotNotifyText: "Don't miss important alerts. With this option, MyBudget will no longer notify you if a payment is unable to be made as scheduled."
	},
	'livingExpensesSent' : {
		name: 'Living expenses sent',
		allowDoNotNotify: true,
		doNotNotifyText: "Don't miss important alerts. With this option, MyBudget will no longer notify you when your living expenses are sent."
	},
	'newWebMessage' : {
		name: 'New Web Message',
		allowDoNotNotify: true,
		doNotNotifyText: "MyBudget will no longer notify you when messages are received. You will still see new messages in the app."
	},
	'other': {
		name: 'Other',
		allowDoNotNotify: false,
		doNotNotifyText: "By selecting this option, MyBudget will no longer notify you for 'Other' communications. Please note that for any critical information we may still notify you."
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/data/communicationSettings.js